import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaWhatsapp } from 'react-icons/fa';
import BranchSelector from '../components/BranchSelector';
import { getSelectedBranch, generateWhatsAppLink, getUpdatedBranches } from '../utils/branchesData';
import { getProductsByCategory } from '../services/api';
import './CategoryPage.css';

function MedicalInstruments() {
  const navigate = useNavigate();
  const [selectedBranch, setSelectedBranch] = useState(getSelectedBranch());
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleBranchChange = (event) => {
      setSelectedBranch(event.detail);
    };
    
    const handleBranchUpdate = () => {
      // Refresh selected branch data when branches are updated
      const updatedBranch = getSelectedBranch();
      setSelectedBranch(updatedBranch);
    };
    
    window.addEventListener('branchChanged', handleBranchChange);
    window.addEventListener('branchesUpdated', handleBranchUpdate);
    
    return () => {
      window.removeEventListener('branchChanged', handleBranchChange);
      window.removeEventListener('branchesUpdated', handleBranchUpdate);
    };
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        // Medical Instruments category has ID 5
        const productsData = await getProductsByCategory(5);
        setProducts(productsData);
      } catch (error) {
        console.error('Error fetching products:', error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="category-page">
      <div className="category-container">
        <div className="category-top-bar">
          <button className="back-button" onClick={() => navigate('/products')}>
            <FaArrowLeft /> Back to Products
          </button>
          <BranchSelector />
        </div>

        <div className="category-page-header">
          <h1>Medical Instruments</h1>
          <p className="category-page-subtitle">
            Quality medical instruments for healthcare professionals including diagnostic tools and monitoring devices.
          </p>
        </div>

        <div className="category-products-grid">
          {loading ? (
            <div className="loading-state">
              <div className="loading-spinner"></div>
              <p>Loading products...</p>
            </div>
          ) : products.length > 0 ? (
            products.map((product, index) => (
              <div key={index} className="category-product-card">
                <div className="category-product-image">
                  <img 
                    src={product.image_url} 
                    alt={product.name}
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = '/pharmacare-logo.png';
                    }}
                  />
                </div>
                <div className="category-product-info">
                  <h3>{product.name}</h3>
                         {selectedBranch.hasWhatsApp ? (
                           <a 
                             href={generateWhatsAppLink(product.name, selectedBranch.whatsapp)}
                             target="_blank"
                             rel="noopener noreferrer"
                             className="inquire-button"
                           >
                             <FaWhatsapp /> Inquire on WhatsApp
                           </a>
                         ) : (
                           <div className="inquire-button disabled">
                             <FaWhatsapp /> WhatsApp Inquiries Not Available
                           </div>
                         )}
                </div>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <p>No products found in this category.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MedicalInstruments;

